/*
 ** Author: Munyingi Ian
 ** Author URL: https://ellixar.com/
 */

let history;
export const registerNav = ref => {
  history = ref.history;
};

const jumpTo = uri => {
  history.push(uri);
  window.location.reload();
};
export const go = uri => {
  history.go(uri);
};
export default jumpTo;
